import { ThemeEvents } from '@theme/events';

function CartCountController() {
  async function updateCartCount() {
    const response = await fetch(`${Shopify.routes.root}cart.js`);

    const cart = await response.json();
    const count = cart.item_count ?? 0;

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 99 ? '99+' : String(count);
      el.classList.toggle('opacity-0', count < 1);
      el.classList.toggle('opacity-100', count >= 1);
    });
  }

  document.addEventListener(ThemeEvents.cartAdd, updateCartCount);
  document.addEventListener(ThemeEvents.cartUpdate, updateCartCount);
}

CartCountController();
